<script setup lang="ts">
import TerminVIew from "./TerminVIew.vue";
import { useRoute } from "vue-router";
import client from "@/utils/axios";
import { computed, onMounted, onUnmounted, ref, watch } from "vue";
import SpinnerLoader from "@/components/Loaders/SpinnerLoader.vue";
import { createClient } from "@supabase/supabase-js";
import PhaseSidemenu from "@/components/Sidebar/Redesign/PhaseSidemenu.vue";
import MainLayout from "@/layouts/MainLayout.vue";
import SecondaryPageHeader from "@/components/PageHeader/SecondaryPageHeader.vue";
import { useUserStore } from "@/stores/user";

const route = useRoute();
const termin = ref<any>([]);
const project = ref();
const selectedTermin = ref();
const selectedPhase = ref();
const isLoading = ref(false);
const isIssuesFeatureFlagActive = ref<boolean>(false);
const userStore = useUserStore();
let currentLanguage = computed(() => userStore.language);
let lastDatabaseTranslationUpdateTimestamp = computed(
  () => userStore.translationsUpdateTimestamp
);

const getTerminData = async () => {
  isLoading.value = true;
  try {
    const response = await client.get(
      `/projects/${route.params.id}/termin/${route.params.terminId}?locale=${currentLanguage.value}`
    );
    termin.value = response.data;

    let newSelectedPhase = "";

    termin.value.phases.forEach((phase: any) => {
      phase.termins.forEach((termin: any) => {
        if (termin.id === route.params.terminId) {
          newSelectedPhase = phase.phase.id;
          if (selectedPhase.value != newSelectedPhase) {
            selectedPhase.value = newSelectedPhase;
          }
        }
      });
    });
  } catch (error) {
    console.log(error);
  } finally {
    isLoading.value = false;
  }
};

watch(
  () => route.params.terminId, // Watch for the 'id' param change in the route
  (newId, oldId) => {
    if (newId !== oldId) {
      getTerminData();
      selectedTermin.value = newId;
    }
  },
  { immediate: true } // Immediately run on component mount
);

const getProjectData = async () => {
  try {
    const response = await client.get(
      `/projects/${route.params.id}?locale=${currentLanguage.value}`
    );
    project.value = response.data;
    isIssuesFeatureFlagActive.value = response.data.isIssuesFeatureFlagActive;
  } catch (error) {
    console.log(error);
  }
};

let supabase = createClient(
  process.env.VUE_APP_SUPABASE_URL || "",
  process.env.VUE_APP_SUPABASE_API_KEY || ""
);

const handleFeatureFlag = (payload: any) => {
  if (payload) {
    isIssuesFeatureFlagActive.value = payload.new?.is_active;
  }
};

onMounted(() => {
  getProjectData();

  supabase
    .channel("feature_flag_issues")
    .on(
      "postgres_changes",
      {
        event: "*",
        schema: "public",
        table: "feature_flag",
        filter: `id=eq.1`,
      },
      handleFeatureFlag
    )
    .subscribe();
});

onUnmounted(() => {
  supabase.removeAllChannels();
});

const salesforceLink = computed(() => {
  if (termin.value) {
    return `https://smalt.lightning.force.com/lightning/r/Phase__c/${termin.value?.notionId}/view`;
  }
  return null;
});

watch(
  currentLanguage,
  async (newLang: any, oldLang: any) => {
    if (newLang && oldLang && newLang !== oldLang) {
      await getProjectData();
      await getTerminData();
    }
  },
  { immediate: true }
);
watch(
  lastDatabaseTranslationUpdateTimestamp,
  async (newTimestamp: any, oldTimestamp: any) => {
    if (newTimestamp && oldTimestamp && newTimestamp !== oldTimestamp) {
      await getProjectData();
      await getTerminData();
    }
  },
  { immediate: true }
);
</script>

<template>
  <MainLayout>
    <SecondaryPageHeader
      :appointment-project="project"
      :appointment-details="termin"
      :salesforce-link="salesforceLink"
    />
    <div class="w-full h-screen relative flex bg-[#EFEEEC] pr-[20px]">
      <div v-if="termin.phases" class="">
        <PhaseSidemenu
          v-if="termin && termin.phases"
          :appointment-page="termin.phases"
          :is-loading="isLoading"
        />
      </div>
      <div class="w-full">
        <TerminVIew
          v-if="!isLoading"
          @refresh="getTerminData"
          :termin="termin"
          :key="termin"
          :project-name="project?.name"
          :is-issues-feature-flag-active="isIssuesFeatureFlagActive"
        />
        <div v-if="isLoading" class="flex items-center justify-center mt-20">
          <SpinnerLoader />
        </div>
      </div>
      <!-- <div v-if="termin?.notion_id" class="w-fit absolute right-0 pr-10">
        <a
          :href="`https://smalt.lightning.force.com/lightning/r/Appointment__c/${termin.notion_id}/view`"
          target="_blank"
          class="w-9 h-9"
        >
          <img
            class="w-9 h-9 cursor-pointer"
            src="@/assets/salesforce.svg"
            alt=""
        /></a>
      </div> -->
    </div>
  </MainLayout>
</template>
